module.exports = __webpack_public_path__ + "img/tech-left.41e5636.png";